import { render, staticRenderFns } from "./dproswipe.vue?vue&type=template&id=f228460c&scoped=true"
import script from "./dproswipe.vue?vue&type=script&lang=js"
export * from "./dproswipe.vue?vue&type=script&lang=js"
import style0 from "./dproswipe.vue?vue&type=style&index=0&id=f228460c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f228460c",
  null
  
)

export default component.exports